<template>
  <q-dialog v-model="show" persistent>
    <q-card class="padding-horizontal-medium">
      <q-toolbar>
        <q-toolbar-title>
            <span class="text-weight-bold" v-if="start">Démarrage</span> 
            <span class="text-weight-bold" v-else>Arrêt</span> 
            de la séance {{seance.code_acces}}
        </q-toolbar-title>
        <q-btn flat round dense icon="close" @click="$emit('cancel')" />
      </q-toolbar>

      <q-card-section>
        <div class="text-h6" v-if="start">Voulez-vous vraiment démarrer la séance : {{seance.code_acces}} ?</div>
        <div class="text-h6" v-else>Voulez-vous vraiment stopper la séance : {{seance.code_acces}} ?</div>
      </q-card-section>


      <q-card-section>
        <p>Code d'accès : {{seance.code_acces}}</p>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn label="Annuler" color="secondary" flat class="q-ml-sm" @click="$emit('cancel')"/>
        <q-btn label="Oui" color="blue" flat @click="$emit('start')" v-if="start"/>
        <q-btn label="Oui" color="red" flat @click="$emit('stop')" v-else/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
export default {
  name: "StartSeanceDialog",
  props: {
    show: Boolean,
    seance: Object,
    start: Boolean,
  },
}
</script>
